import { defineMessages } from 'react-intl'

const messages = defineMessages({
  columnIndicator: {
    id: 'ReportTable.columnIndicator',
    description: 'Cabecera de columna',
    defaultMessage: 'Indicador'
  },
  columnYear: {
    id: 'ReportTable.columnYear',
    description: 'Cabecera de columna',
    defaultMessage: 'Año'
  },
  columnValue: {
    id: 'ReportTable.columnValue',
    description: 'Cabecera de columna',
    defaultMessage: 'Valor'
  },
  columnEvo: {
    id: 'ReportTable.columnEvo',
    description: 'Cabecera de columna',
    defaultMessage: 'Evolución'
  },
  columnEvoLastYear: {
    id: 'ReportTable.columnEvoLastYear',
    description: 'Cabecera de columna',
    defaultMessage: 'último año'
  },
  columnEU27Header: {
    id: 'ReportTable.columnEU27Header',
    description: 'Cabecera de columna',
    defaultMessage: 'Posicionamiento relativo UE27'
  },
  columnLevel: {
    id: 'ReportTable.columnLevel',
    description: 'Cabecera de columna',
    defaultMessage: 'Nivel'
  },
  columnChange: {
    id: 'ReportTable.columnChange',
    description: 'Cabecera de columna',
    defaultMessage: 'Cambio'
  },
});

export default messages;


// WEBPACK FOOTER //
// ./src/modules/Content/ReportTableContainer/messages.js